<script setup lang="tsx">
import { computed } from 'vue'
import type { StandardRuleMetaData } from '@/models/api-generated'

import methodEditor from '@/stores/method-editor'
import RuleStatusSelect from '@/components/widgets/RuleStatusSelect.vue'
import RuleStatusIcon from '@/components/widgets/RuleStatusIcon.vue'

const props = defineProps({
	isReadOnly: Boolean,
})

const model = defineModel<StandardRuleMetaData>({ required: true })
const editor = methodEditor()
const isEditMode = computed(() => !props.isReadOnly && editor.isEditMode)
</script>

<template>
	<template v-for="(subRule, i) in model.sub_rules" :key="subRule.id">
		<div class="row">
			<div class="col-8 d-inline-flex align-items-start">
				<i class="bi bi-arrow-return-right fs-6 text-secondary me-1 mt-0"></i>
				<div class="d-flex flex-column">
					<div>{{ subRule.rule.value }}</div>
					<div v-if="model.sub_rules[i].comment || isEditMode" class="ms-1">
						<div v-if="!isEditMode"><i class="bi bi-chat-right-text me-1 text-primary"></i>{{ model.sub_rules[i].comment }}</div>
						<textarea
							v-else
							:id="'subrule-comment' + model.sub_rules[i].id"
							class="form-control mt-1 mb-2"
							maxlength="500"
							v-model="model.sub_rules[i].comment"
							:placeholder="$t('misc.comment')"
							:disabled="props.isReadOnly"
						></textarea>
					</div>
				</div>
			</div>

			<div class="col align-self-center text-center">
				<RuleStatusIcon v-if="!isEditMode" v-model="model.sub_rules[i].status"></RuleStatusIcon>
				<RuleStatusSelect
					v-else
					:id="'subrule-status-select' + model.sub_rules[i].id"
					v-model="model.sub_rules[i].status"
					class="mt-1"
					:disabled="props.isReadOnly"
				></RuleStatusSelect>
			</div>
		</div>
		<hr v-if="i < model.sub_rules.length - 1" class="my-0" />
	</template>
</template>
